module.exports = __webpack_public_path__ + "static/img/fenzuhanhua.f1e3c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/fenzuhanhua.png
// module id = jIkm
// module chunks = 24